<template>
  <div class="account-hover">
    <div class="account-hover__user">
      <div class="account-hover__user--card">
        <div class="account-hover__user--card__name">{{ displayName }}</div>

        <div class="account-hover__user--card__verified" :class="statusColorClass">
          <p-icon :icon="statusIcon" :color="statusIconColor" size="sm" class="mr-4" />
          {{ statusText }}
        </div>
      </div>

      <p-icon v-if="$device.isDesktop" icon="arrow-top-right" color="fg-primary" size="md" />
    </div>

    <p-divider size="2px" class="my-16" />

    <div class="account-hover__items">
      <p-list :title="$t('general.supportTickets')" hover @on-click="goToSupportRequests">
        <template #prepend>
          <p-icon icon="list-check" size="xmd" color="fg-primary" />
        </template>
        <template v-if="openTicketsCount > 0" #append>
          <p-badge :text="openTicketsCount" color="success" size="lg" />
        </template>
      </p-list>
      <p-list :title="$t('general.signout')" hover @on-click="onSignOut">
        <template #prepend>
          <p-icon icon="exit" size="xmd" color="fg-primary" />
        </template>
      </p-list>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useUserStore } from '@/store/user'
import { useHelpdeskChatStore } from '@/store/helpdeskChat'
import { smartRouter } from '@/composables'

const { user, fetchUser, isLoggedIn } = useUserStore()
const helpdeskChat = useHelpdeskChatStore()

const displayName = computed(() => user.info.name || '')

const kycStatus = computed(() => (user.info.kyc_status || '').toString())
const isVerified = computed(() => kycStatus.value === 'verified')
const statusText = computed(() => {
  return isVerified.value ? $t('general.verified') : 'Doğrulanmamış hesap'
})
const statusColorClass = computed(() => (isVerified.value ? 't-fg-accent' : 't-fg-warning'))
const statusIcon = computed(() => (isVerified.value ? 'shield-verified' : 'shield-unverified'))
const statusIconColor = computed(() => (isVerified.value ? 'fg-accent' : 'fg-warning'))

// Not-closed (≠5) talep sayısı; PHeader listeyi fetch ediyor.
const openTicketsCount = computed(() => helpdeskChat.openTicketsCount)

const goToSupportRequests = () => {
  smartRouter.go('/ticket')
}

onMounted(async () => {
  if (isLoggedIn && !user.isAuthenticated) {
    await fetchUser()
  }
})

function onSignOut(): void {
  try {
    localStorage.removeItem('auth-token')
    helpdeskChat.clearState()
  } catch {}
  window.location.reload()
}
</script>
